module.exports = "https://coursera_assets.s3.amazonaws.com/images/320eeda8847d0a7f72692f04e95f71cd.png";